import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment, domainRaw } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-feedback-fab',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './feedback-widget.component.html',
  styleUrls: ['./feedback-widget.component.scss'],
})
export class FeedbackWidgetComponent {
  isOpen = false;
  isSubmitting = false;
  submitted = false;
  mode = (environment as any).mode || '';

  feedback = {
    portal: 'customer' as const,
    page: '',
    category: 'general' as 'bug' | 'enhancement' | 'ui' | 'general',
    priority: 'medium' as 'low' | 'medium' | 'high' | 'critical',
    title: '',
    description: '',
    submittedBy: '',
  };

  categories = [
    { value: 'bug', label: 'Bug' },
    { value: 'enhancement', label: 'Enhancement' },
    { value: 'ui', label: 'UI/UX' },
    { value: 'general', label: 'General' },
  ];

  priorities = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
    { value: 'critical', label: 'Critical' },
  ];

  constructor(private http: HttpClient) {}

  toggle() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.feedback.page = window.location.pathname;
      this.submitted = false;
    }
  }

  submit() {
    if (!this.feedback.title || !this.feedback.description) return;
    this.isSubmitting = true;

    this.http
      .post(`${domainRaw}/company/public/feedback`, this.feedback)
      .subscribe({
        next: () => {
          this.isSubmitting = false;
          this.submitted = true;
          this.resetForm();
        },
        error: () => {
          this.isSubmitting = false;
        },
      });
  }

  resetForm() {
    this.feedback = {
      portal: 'customer',
      page: window.location.pathname,
      category: 'general',
      priority: 'medium',
      title: '',
      description: '',
      submittedBy: this.feedback.submittedBy,
    };
  }
}
